import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import games from './modules/games';
import profile from './modules/profile';
import * as getters from './getter';

Vue.use(Vuex);

const store = new Vuex.Store({
  strict: true, // process.env.NODE_ENV !== 'production',
  getters,
  modules: {
    auth,
    games,
    profile,
  },
  state: {
  },
  mutations: {
  },
  userInfo: {},
  isLogin: false,
});

export default store;
